import { Component, ElementRef, HostListener, Input } from '@angular/core'
import { ProgressIndicatorService } from '@mmx/shared'

@Component({
  selector: 'mmx-copy-text',
  template: '<ng-content></ng-content>',
  styles: [
    `
      :host {
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    `,
  ],
  standalone: false,
})
export class CopyTextComponent {
  @Input() copyValue: string

  @HostListener('click') onClick() {
    this.copy()
  }

  constructor(
    private el: ElementRef,
    private progressService: ProgressIndicatorService,
  ) {}

  copy() {
    const text =
      this.copyValue || this.el.nativeElement.textContent
    if (!text) {
      return
    }

    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(text).then(() => {
        this.progressService.snack('Text copied!')
      }).catch(() => {
        this.progressService.snack('Unable to copy text.')
      })
      return
    }

    this.progressService.snack('Copy not supported in this browser.')
  }
}
